/**
 * BelgeSablonuBaglantilari.jsx — bir belgenin yanındaki "Şablonu indir" / "Örneği görüntüle" bağlantıları (backlog #503).
 *
 * `sablon` = documentTemplateService.sablonHaritasi(...)[fileTypeId]: { bosForm?: {ad, url}, ornek?: {ad, url} }.
 * Boş form (indirilip imzalanıp geri yüklenen) ve örnek (dolu bir belgenin nasıl görüneceği) yeni sekmede açılır;
 * ikisi de yoksa hiçbir şey çizilmez, böylece çağıran yer şablon olup olmadığına bakmak zorunda kalmaz.
 */
import React from "react";
import { Download, Eye } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * @param sablon         belge türünün haritadaki girdisi (yoksa bileşen boş döner)
 * @param bosFormEtiketi boş form bağlantısının yazısı (varsayılan: "Şablonu indir"); örnek bağlantısı hep "Örneği görüntüle"
 * @param className      sarmalayıcı sınıfı; her bağlantı kendi satırında
 */
export default function BelgeSablonuBaglantilari({ sablon, bosFormEtiketi, className = "mt-2 small" }) {
  const { t } = useTranslation("common");
  if (!sablon?.bosForm && !sablon?.ornek) return null;
  return (
    <div className={className} data-testid="belge-sablonu-baglantilari">
      {sablon.bosForm && (
        <div>
          <a href={sablon.bosForm.url} target="_blank" rel="noreferrer" title={sablon.bosForm.ad} data-testid="sablon-bos-form">
            <Download size={12} className="me-1" />{bosFormEtiketi ?? t("sablonuIndir")}
          </a>
        </div>
      )}
      {sablon.ornek && (
        <div>
          <a href={sablon.ornek.url} target="_blank" rel="noreferrer" title={sablon.ornek.ad} data-testid="sablon-ornek">
            <Eye size={12} className="me-1" />{t("ornegiGoruntule")}
          </a>
        </div>
      )}
    </div>
  );
}
